export const getTotalBudgetedRowCel = (sortedMinistrationsPlan, status) => {
  const periodColumns = {}
  let totalInvestment = 0

  sortedMinistrationsPlan.forEach(({ ministrationBudget, orderIndex }) => {
    const getTotalInvestment = () => {
      return Number(ministrationBudget?.implementer || 0)
        + Number(ministrationBudget?.alliedOne || 0)
        + Number(ministrationBudget?.alliedTwo || 0)
        + Number(ministrationBudget?.ficosec || 0)
    }

    periodColumns[`period${orderIndex}`] = getTotalInvestment()
    periodColumns[`period${orderIndex}-ficosec-investment`] = Number(ministrationBudget?.ficosec || 0)
    periodColumns[`period${orderIndex}-implementer-investment`] = Number(ministrationBudget?.implementer || 0)
    periodColumns[`period${orderIndex}-allied-investment`] = Number(ministrationBudget?.alliedOne || 0)
      + Number(ministrationBudget?.alliedTwo || 0)
    totalInvestment += getTotalInvestment()
  })
  return { status, ...periodColumns, totalInvestment }
}
